export default "__VITE_ASSET__cd4fcfb8__"